import { render } from "./HeaderReports.vue?vue&type=template&id=6d2599c5&scoped=true"
import script from "./HeaderReports.vue?vue&type=script&lang=js"
export * from "./HeaderReports.vue?vue&type=script&lang=js"

import "./HeaderReports.vue?vue&type=style&index=0&id=6d2599c5&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2599c5"]])

export default __exports__